import { useMemo, useRef } from "react"

/** Each claim outdates every earlier one, so only the newest answer is applied. */
export const useNewestOnly = () => {
  const generation = useRef(0)
  return useMemo(
    () => ({
      claim: () => {
        const mine = ++generation.current
        return () => generation.current === mine
      }
    }),
    []
  )
}
